const TOLL_FREE_AREA_CODES = new Set(["800", "833", "844", "855", "866", "877", "888"]);

export function validateBandwidthAreaCode(areaCode: string): string | null {
  const normalized = areaCode.trim();
  if (!/^[2-9][0-9]{2}$/.test(normalized)) {
    return "Area code must be a 3-digit US number that does not start with 0 or 1.";
  }
  if (normalized.startsWith("96") || normalized.startsWith("37")) {
    return `Area code ${normalized} is reserved and cannot be used. Try a different area code.`;
  }
  if (normalized.endsWith("11")) {
    return "Area code cannot end in 11. Try a different area code.";
  }
  if (TOLL_FREE_AREA_CODES.has(normalized)) {
    return "Toll-free area codes cannot be used for MMS sender numbers. Try a local area code.";
  }
  return null;
}

export function formatMmsApiErrorMessage(
  err: unknown,
  fallback: string
): string {
  const raw =
    err instanceof Error
      ? err.message
      : typeof err === "string"
      ? err
      : "";

  if (!raw.trim()) {
    return fallback;
  }

  const normalized = raw.trim();
  const lower = normalized.toLowerCase();

  if (
    normalized === "Load failed" ||
    normalized === "Failed to fetch" ||
    lower.includes("networkerror") ||
    lower.includes("network request failed")
  ) {
    return "Could not reach the admin service. Check your connection and try again.";
  }

  const areaCodePrefix = "Failed to check area code availability: ";
  if (normalized.startsWith(areaCodePrefix)) {
    return normalized.slice(areaCodePrefix.length).trim() || fallback;
  }

  const portabilityPrefix = "Failed to check phone portability: ";
  if (normalized.startsWith(portabilityPrefix)) {
    return normalized.slice(portabilityPrefix.length).trim() || fallback;
  }

  if (normalized.startsWith("HTTP ")) {
    return fallback;
  }

  return normalized;
}
